"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallbackEvent = void 0;
/**
 * The types of events that can trigger a callback.
 *
 * *Swagger Schema Reference :* `CallbackEvent`
 */
var CallbackEvent;
(function (CallbackEvent) {
    /**
     * The status of the task has been set to "done".
     */
    CallbackEvent["STATUS_SET_TO_DONE"] = "STATUS_SET_TO_DONE";
    /**
     * The status of the task has been set to "error".
     */
    CallbackEvent["STATUS_SET_TO_ERROR"] = "STATUS_SET_TO_ERROR";
})(CallbackEvent = exports.CallbackEvent || (exports.CallbackEvent = {}));
//# sourceMappingURL=callback.js.map